export const LastUpdated = '5 Avril 2026';
